<template>
  <main class="purchase-main settings">
    <app-loading v-if="isLoading"></app-loading>
    <div v-else>
      <section class="retry-area" v-if="responseError">
        <h3 class="retry-area__ttl">通信に失敗しました</h3>
        <a href="javascript:void(0);" @click="getUserSettings" class="btn-retry btn-retry--short">リトライ</a>
      </section>
      <div v-else>
        <ul class="radio-cards">
          <li v-for="paymentWay in paymentsWays" @click="choosePaymentsWay(paymentWay[0])"><a href="javascript:void(0);" :class="{'is-active': paymentWay[0] === selectedPaymentsWay}" class="radio-card">{{paymentWay[1]}}</a></li>
        </ul>
        <div class="purchase-main__next">
          <span class="btn-square" @click="changePaymentWay()" v-if="selectedPaymentsWay">変更する</span>
          <span class="btn-square btn-square--disabled" v-else>変更する</span>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  import { paymentsWays, credit } from '../../constants';
  import Loading from '../common/Loading.vue';

  export default {
    title: 'お支払い方法 | abceed（No.1 TOEIC教材アプリ）',
    headerTitle: 'お支払い方法',
    description: 'abceed のお支払い方法はこちら',
    keywords: 'toeic,abceed,globee,お支払い方法',
    headerType: 'historyBackNotSearch',
    components: {
      appLoading: Loading
    },
    data() {
      return {
        paymentsWays,
        selectedPaymentsWay: null,
        sbps_payment_type: null,
        responseError: false,
      }
    },
    created() {
      this.getUserSettings();
    },
    computed: {
      isLoading() {
        return this.$store.getters.isLoading;
      },
      userSettings() {
        return this.$store.getters.userSettings;
      }
    },
    methods: {
      getUserSettings() {
        this.$store.dispatch("changeLoadingCondition", true);
        this.$store.dispatch('getUserSettings', {token:""})
          .then(data => {
            this.responseError = data === 'error';
            if (!!data.user.sbps_payment_type) {
              this.selectedPaymentsWay = data.user.sbps_payment_type;
              this.sbps_payment_type = data.user.sbps_payment_type;
            }
            this.$store.dispatch("changeLoadingCondition", false);
          })
          .catch(err => {
            this.$store.dispatch("changeLoadingCondition", false);
          });
      },
      choosePaymentsWay(index) {
        this.selectedPaymentsWay = index;
      },
      changePaymentWay() {
        const paymentWayType = paymentsWays.map(ary => {
          return ary[0];
        });
        if (paymentWayType.indexOf(this.selectedPaymentsWay) == -1 || this.selectedPaymentsWay === null) {
          alert('不正な値が挿入されています。');
          return;
        }
        if (this.selectedPaymentsWay !== credit) {
          this.$store.dispatch("changeLoadingCondition", true);
          this.$store.dispatch("updatePaymentsWay", { payment_type: this.selectedPaymentsWay })
            .then(data => {
              if (data === 'error') {
                alert('通信に失敗しました。再度、更新をお試しください。');
                this.$store.dispatch("changeLoadingCondition", false);
                return;
              }
              this.$store.dispatch('getUserSettings', {token:""})
                .then(() => {
                  alert('正常に支払い方法が変更されました。');
                  this.$store.dispatch("changeLoadingCondition", false);
                })
                .catch(() => {
                  alert('通信に失敗しました。再度、更新をお試しください。');
                  this.$store.dispatch("changeLoadingCondition", false);
                });
            })
            .catch(() => {
              alert('通信に失敗しました。再度、更新をお試しください。');
              this.$store.dispatch("changeLoadingCondition", false);
            });
        } else {
          //クレジットカードに変更するケース
          this.$store.dispatch("changeLoadingCondition", true);
          this.$store.dispatch('getCreditsInfo')
            .then(data => {
              if (data.message === 'Not found credit card.' || data.message === 'Some error occurred.') {
                //クレジットカード情報が存在しないので登録画面へ
                this.$store.dispatch("changeLoadingCondition", false);
                this.$router.push({ name: 'settingCreditCard', params: { method: 'register' }});
              } else {
                //クレジットカード情報が存在する場合、必要なら支払いタイプ変更を行ってから編集画面に移る
                if (this.sbps_payment_type !== credit) {
                  this.$store.dispatch("changeLoadingCondition", true);
                  this.$store.dispatch("updatePaymentsWay", { payment_type: this.selectedPaymentsWay })
                    .then(data => {
                      if (data === 'error') {
                        alert('通信に失敗しました。再度、更新をお試しください。');
                        this.$store.dispatch("changeLoadingCondition", false);
                        return;
                      }
                      this.$store.dispatch('getUserSettings', {token:""})
                        .then(() => {
                          alert('正常に支払い方法が変更されました。');
                          this.$router.push({ name: 'settingCredit', params: { method: 'update' }})
                        })
                        .catch(() => {
                          alert('通信に失敗しました。再度、更新をお試しください。');
                          this.$store.dispatch("changeLoadingCondition", false);
                        });
                    })
                    .catch(() => {
                      alert('通信に失敗しました。再度、更新をお試しください。');
                      this.$store.dispatch("changeLoadingCondition", false);
                    });
                } else {
                  this.$store.dispatch("changeLoadingCondition", false);
                  this.$router.push({ name: 'settingCredit', params: { method: 'update' }})
                }
              }
            }).catch(() => {
            alert('通信に失敗しました。再度、更新をお試しください。');
            this.$store.dispatch("changeLoadingCondition", false);
          });
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/PaymentWay.vue